
import s from './simulador/state'
import * as a from './simulador/actions'
import * as m from './simulador/mutations'
import * as g from './simulador/getters'

export const state = s
export const actions = {...a}
export const mutations = {...m}
export const getters = {...g}
